import React from 'react'

import DatasetContainer from './dataset/Dataset.container'
import GridContainer from './grid/Grid.container'
import ScrollerContainer from './scroller/Scroller.container'
import Pagination from '../pagination'
import ErrorsContainer from './errors/Errors.container'
import HeaderContainer from './header/Header.container'
import FilterDrawerContainer from './filters/FilterDrawer.container'
import StatusContainer from './status/Status.container'

import SaveFilterDialogContainer from './dialogs/savefilterdialog/SaveFilterDialog.container'
import SaveFilterErrorDialogContainer from './dialogs/savefilterdialog/SaveFilterErrorDialog.container'
import ExportContainer from './dialogs/exportdialog/Export.container'
import HeaderSearchMobileContainer from './dialogs/headersearchmobile/HeaderSearchMobile.container'

import Prompt from '../dialog'

import Loader from "@emcm-ui/component-loader"
import { DatatableOuter, ScrollerPlaceholder, LoaderWrapper } from './Datatable.styles'

const DatatableComponent = ({
  titleFormatter,
  setSelectedRows,
  i18n,
  api,
  analytics,
  env,
  setSearch,
  unsetSearch,
  handleExportDialogOpen,
  state,
  handleSaveFilters,
  handleFilterOpen,
  closeFilterOnExportClick,
  handleFilter,
  savedFilters,
  handleSort,
  handleRemoveFilter,
  appliedFilters,
  customFilter,
  sort,
  gridWidth,
  setOffset,
  handleMobileSwitch,
  handlePaginationJump,
  handlePaginationSeek,
  onSaveClose,
  onSearchClose,
  handleSave,
  handleSearch,
  handleRemove,
  onExportClose,
  filters,
  props,
  wrapper,
  selectedRows,
  saveFilterError
}) => {
  const { data, pagination, error, extraFilters, saveFilterDialogOpen, exportDialogOpen, searchDialogOpen, download, datasetWidth, filterDrawerOpen, serverRequestInFlight } = state
  const { errorHandling } = props

  const searchValue = api.getSearch() || ''

  return (
    <DatatableOuter>
      <DatasetContainer>
        <HeaderContainer
          titleFormatter={titleFormatter}
          search={searchValue}
          pagination={pagination}
          env={env}
          analytics={analytics}
          i18n={i18n}
          api={api}
          selectedRows={selectedRows}
          download={download}
          handleFilterOpen={handleFilterOpen}
          handleSearchOpen={onSearchClose}
          closeFilterOnExportClick={closeFilterOnExportClick}
          setSearch={setSearch}
          unsetSearch={unsetSearch}
          handleExportDialogOpen={handleExportDialogOpen}
          {...state} />

        {filterDrawerOpen && data &&
          <FilterDrawerContainer
            analytics={analytics}
            env={env}
            i18n={i18n}
            extraFilters={extraFilters}
            api={api}
            handleSaveFilters={handleSaveFilters}
            handleFilterOpen={handleFilterOpen}
            handleFilter={handleFilter}
            appliedFilters={appliedFilters}
            handleRemoveFilter={handleRemoveFilter}
            handleRemove={handleRemove}
            {...state}
            savedFilters={savedFilters} />
        }

        <StatusContainer
          analytics={analytics}
          api={api}
          env={env}
          i18n={i18n}
          handleSort={handleSort}
          handleRemoveSearch={unsetSearch}
          handleRemoveFilter={handleRemoveFilter}
          handleFilter={handleFilter}
          customFilter={customFilter}
          search={searchValue}
          sort={sort}
          filters={filters} />

        {data &&
          <GridContainer
            {...state}
            serverRequestInFlight={serverRequestInFlight}
            setSelectedRows={setSelectedRows}
            selectedRows={selectedRows}
            gridWidth={gridWidth}
            api={api}
            handleSort={handleSort}
            handleFilter={handleFilter}
            i18n={i18n}
            analytics={analytics}
            env={env} />
        }

        {
          (!data && !error &&
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
          )
        }

        {/* Scroller, or if not needed an empty placeholder, to keep layout proportions consistent */}
        {datasetWidth && (datasetWidth <= gridWidth)
          ? <ScrollerContainer {...state} analytics={analytics} setOffset={setOffset} gridWidth={gridWidth} handleMobileSwitch={handleMobileSwitch} env={env} />
          : <ScrollerPlaceholder />
        }
      </DatasetContainer>
      {
        data && pagination && (api.basicPaginationEnabled || api.getTotalItems() > pagination.pageSize) &&
          <Pagination
            criterion={{
              total: api.getTotalItems(),
              _perpage: pagination.pageSize,
              _page: 1,
              basicPaginationEnabled: api.basicPaginationEnabled,
              moreItems: api.moreItems,
              lessItems: api.lessItems
            }}
            config={{
              previousPageLabel: pagination.previousPageLabel,
              nextPageLabel: pagination.nextPageLabel,
              onCurrentIndexChanged: (idx, action) => {
                handlePaginationSeek(idx + 1, action)
              }
            }}
            currentIndex={api.pagination.offset - 1}
          />
      }
      {/* {data && pagination && api.getTotalItems() > pagination.pageSize && */}
        {/*   <PaginationContainer handlePaginationJump={handlePaginationJump} handlePaginationSeek={handlePaginationSeek} api={api} i18n={i18n} env={env} /> */}
      {/* } */}

      {error &&
        <ErrorsContainer error={error} errorHandling={errorHandling} containerRef={wrapper} env={env} />
      }

      {data && !serverRequestInFlight && saveFilterDialogOpen && !saveFilterError && 
        <Prompt type='page' active={true} onClose={onSaveClose}>
          <SaveFilterDialogContainer 
            saveFilterError={saveFilterError} 
            onClose={onSaveClose} 
            handleSave={handleSave} 
            i18n={i18n} 
            env={env} 
            analytics={analytics} 
          />
        </Prompt>
      }

      {data && !serverRequestInFlight && !saveFilterDialogOpen && saveFilterError &&
        <Prompt type='page' active={true} onClose={onSaveClose}>
          <SaveFilterErrorDialogContainer  
            saveFilterError={saveFilterError} 
            onClose={onSaveClose} 
            i18n={i18n}
            analytics={analytics}
           />
        </Prompt>
      }

      {searchDialogOpen &&
        <HeaderSearchMobileContainer 
          search={searchValue} 
          onClose={onSearchClose} 
          handleSearch={handleSearch} 
          i18n={i18n} 
          env={env} 
          analytics={analytics} 
        />
      }

      {exportDialogOpen &&
        <Prompt type='page' active={true} onClose={onExportClose} env={env}>
           <ExportContainer 
            analytics={analytics} 
            title={state.title} 
            i18n={i18n} 
            onClose={onExportClose} 
            api={api} 
            download={download} 
            env={env} 
          />
        </Prompt>
      }
    </DatatableOuter>
  )
}

export default DatatableComponent
